import { IJSendSuccessResponse, IRefundAccountEntityV3 } from "typings";
import { fetcher } from "utils";

// v3 환불 계좌 조회
export const get__members__refund__accounts_v3 = (): Promise<IJSendSuccessResponse<{
  payload: IRefundAccountEntityV3;
}>> => fetcher.get("/api/v3/members/refund-bank-account");
